/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { preanalysisControllerGetQuestions } from '../fn/preanalysis/preanalysis-controller-get-questions';
import { PreanalysisControllerGetQuestions$Params } from '../fn/preanalysis/preanalysis-controller-get-questions';
import { preanalysisControllerSubmitAnswers } from '../fn/preanalysis/preanalysis-controller-submit-answers';
import { PreanalysisControllerSubmitAnswers$Params } from '../fn/preanalysis/preanalysis-controller-submit-answers';
import { PreanalysisQuestionModelDto } from '../models/preanalysis-question-model-dto';
import { ProcessingJobModelDto } from '../models/processing-job-model-dto';

@Injectable({ providedIn: 'root' })
export class PreanalysisService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `preanalysisControllerGetQuestions()` */
  static readonly PreanalysisControllerGetQuestionsPath = '/match-videos/{uuid}/questions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preanalysisControllerGetQuestions()` instead.
   *
   * This method doesn't expect any request body.
   */
  preanalysisControllerGetQuestions$Response(params: PreanalysisControllerGetQuestions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PreanalysisQuestionModelDto>>> {
    return preanalysisControllerGetQuestions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preanalysisControllerGetQuestions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  preanalysisControllerGetQuestions(params: PreanalysisControllerGetQuestions$Params, context?: HttpContext): Observable<Array<PreanalysisQuestionModelDto>> {
    return this.preanalysisControllerGetQuestions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PreanalysisQuestionModelDto>>): Array<PreanalysisQuestionModelDto> => r.body)
    );
  }

  /** Path part for operation `preanalysisControllerSubmitAnswers()` */
  static readonly PreanalysisControllerSubmitAnswersPath = '/match-videos/{uuid}/questions/answers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preanalysisControllerSubmitAnswers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  preanalysisControllerSubmitAnswers$Response(params: PreanalysisControllerSubmitAnswers$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessingJobModelDto>> {
    return preanalysisControllerSubmitAnswers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preanalysisControllerSubmitAnswers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  preanalysisControllerSubmitAnswers(params: PreanalysisControllerSubmitAnswers$Params, context?: HttpContext): Observable<ProcessingJobModelDto> {
    return this.preanalysisControllerSubmitAnswers$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProcessingJobModelDto>): ProcessingJobModelDto => r.body)
    );
  }

}
